/** @format */

export const DEFAULT_TEST_ID = 'control-group';
